let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2lYQg")).then(() => parcelRequire('g4c2X'));